var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"app-shell"},[_c('AppHeader'),_c('div',{staticClass:"layout"},[_c('AppSidebar'),_c('main',{staticClass:"main"},[_c('router-view')],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }